import { Admin, Resource, Layout, type LayoutProps } from 'react-admin';
import GroupIcon from '@mui/icons-material/Group';
import PhotoIcon from '@mui/icons-material/Photo';
import ReportIcon from '@mui/icons-material/Report';
import EventIcon from '@mui/icons-material/Event';
import HistoryIcon from '@mui/icons-material/History';
import { authProvider } from './auth/authProvider';
import { dataProvider } from './data/dataProvider';
import { Dashboard } from './dashboard/Dashboard';
import { UsersList } from './resources/users/UsersList';
import { UserShow } from './resources/users/UserShow';
import { PhotosList } from './resources/photos/PhotosList';
import { ReportsList } from './resources/reports/ReportsList';
import { ReportShow } from './resources/reports/ReportShow';
import { InvitationsList } from './resources/invitations/InvitationsList';
import { InvitationShow } from './resources/invitations/InvitationShow';
import { AuditLogList } from './resources/auditLog/AuditLogList';

function AdminLayout(props: LayoutProps): JSX.Element {
  return <Layout {...props} />;
}

export function App(): JSX.Element {
  return (
    <Admin
      authProvider={authProvider}
      dataProvider={dataProvider}
      layout={AdminLayout}
      dashboard={Dashboard}
      title="Melissa Admin"
      requireAuth
    >
      <Resource
        name="users"
        list={UsersList}
        show={UserShow}
        icon={GroupIcon}
        options={{ label: 'Пользователи' }}
      />
      <Resource name="photos" list={PhotosList} icon={PhotoIcon} options={{ label: 'Фото' }} />
      <Resource
        name="reports"
        list={ReportsList}
        show={ReportShow}
        icon={ReportIcon}
        options={{ label: 'Жалобы' }}
      />
      <Resource
        name="invitations"
        list={InvitationsList}
        show={InvitationShow}
        icon={EventIcon}
        options={{ label: 'Приглашения' }}
      />
      <Resource
        name="auditLogs"
        list={AuditLogList}
        icon={HistoryIcon}
        options={{ label: 'Журнал действий' }}
      />
    </Admin>
  );
}
